import * as React from 'react';
import { Link } from 'react-router-dom';

import { addModifiers } from '../../shared/helpers';

import './Box.scss';

interface BoxProps {
  title: string;
  hasStar?: boolean;
  starStatus?: string[];
  modifiers?: string[];
  modifiersMain?: string[];
  hasVideo?: boolean;
  videoThumb?: string;
  checkStatus?: boolean;
  headerInfo?: string;
  headerProgressInfo?: string;
  headerProgressInfoModifiers?: string[];
  children: JSX.Element[] | JSX.Element;
  hasMedia?: boolean;
  mediaUrl?: string | null;
  tagMedia?: string;
  link?: string;
  videoUUID?: string;
  linkInside?: string;
  source?: string;
  onClick?: () => void;
}

interface BoxMediaProps {
  link?: string;
  hasMedia?: boolean;
  mediaUrl: string | null;
  linkInside?: string;
  tagMedia?: string;
}

const BoxMedia = ({ hasMedia, mediaUrl, link, linkInside, tagMedia }: BoxMediaProps) => {
  if (hasMedia) {
    const mediaStyle = mediaUrl ? { backgroundImage: `url('${mediaUrl}')` } : {};
    if (link) {
      return (
        <a href={link} className="box__media" style={mediaStyle} target="blank">
          {tagMedia !== '' && <span className="box__media-tag">{tagMedia}</span>}
        </a>
      );
    } else if (linkInside) {
      return (
        <Link to={linkInside ? linkInside : '#'} className="box__media" style={mediaStyle}>
          {tagMedia !== '' && <span className="box__media-tag">{tagMedia}</span>}
        </Link>
      );
    } else {
      return (
        <div className="box__media" style={mediaStyle}>
          {tagMedia !== '' && <span className="box__media-tag">{tagMedia}</span>}
        </div>
      );
    }
  } else {
    return null;
  }
};
interface ThumbnailUrlArguments {
  source: string;
  videoId: string;
}

export function getThumbnailUrl({ source, videoId }: ThumbnailUrlArguments) {
  const isVidyard = source.toLowerCase() === 'vidyard';
  const imgSrc = isVidyard ? `//play.vidyard.com/${videoId}.jpg` : `//img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  return imgSrc;
}

export const Box = ({
  title,
  children,
  starStatus = [],
  checkStatus = false,
  hasStar = true,
  hasVideo = false,
  headerInfo = '',
  headerProgressInfo = '',
  headerProgressInfoModifiers = [],
  modifiers = [],
  modifiersMain = [],
  hasMedia = false,
  mediaUrl = null,
  tagMedia = '',
  link,
  videoUUID = '',
  linkInside = '',
  source = '',
  onClick,
}: BoxProps): JSX.Element => (
  <div className={addModifiers('box', modifiers)} onClick={onClick}>
    {hasVideo && source !== '' && (
      <Link className="video_ref" to={linkInside ? linkInside : '#'}>
        <div className="video_play_icon">
          <div className="play_icon" />
        </div>
        <img className="box__video" src={getThumbnailUrl({ source, videoId: videoUUID })} />
      </Link>
    )}
    <BoxMedia hasMedia={hasMedia} mediaUrl={mediaUrl} tagMedia={tagMedia} link={link} linkInside={linkInside} />
    <div className={addModifiers('box__main', modifiersMain)}>
      <div className="box__header">
        {link ? (
          <a target="blank" href={link}>
            <h3 className="box__title">{title}</h3>
          </a>
        ) : linkInside ? (
          <Link to={linkInside ? linkInside : '#'}>
            <h3 className="box__title">{title}</h3>
          </Link>
        ) : (
          <h3 className="box__title">{title}</h3>
        )}
        <div className="box__header-actions">
          {checkStatus && (
            <div className="box__header-actions">
              {checkStatus && <span className="box__header-check" />}
              {hasStar && <span className={addModifiers('box__header-star', starStatus)} />}
            </div>
          )}
        </div>
      </div>
      {headerInfo !== '' && (
        <div className="box__header-info">
          {linkInside ? (
            <Link to={linkInside ? linkInside : '#'}>
              <h3 className="box__header-info-text">{headerInfo}</h3>
            </Link>
          ) : (
            <div className="box__header-info-text">{headerInfo}</div>
          )}
          {checkStatus && headerProgressInfo && (
            <div className={addModifiers('box__header-info-progress', headerProgressInfoModifiers)}>{headerProgressInfo}</div>
          )}
        </div>
      )}
      <div className="box__content">{children}</div>
    </div>
  </div>
);
